<div class="center">
    <div class="container-fluid h-100">
        <div class="row h-100 align-items-center">
            <div class="col-12 text-center">
                <p>We are upgrading our system. Please check back later</p>
                <a class="text-white" [routerLink]="['/']">Go to Appllication</a>
            </div>
        </div>
    </div>
</div>